export const messages = {
  en: {
    doDining: {
      selectGoods: 'Select Goods',
      scanQrCode: 'Please scan QR code',
      dining: 'Dining',
      diningRecords: 'Dining Records',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      enterOwnerName: 'Enter owner name',
      enterDinerName: 'Enter diner name',
      diningTime: 'Dining Time',
      goods: 'Goods',
      owner: 'Owner',
      diner: 'Diner',
      dinerPhone: 'Diner Phone',
      orderNo: 'Order No',
      remark: 'Remark'
    },
    addReserveDiningPerson: {
      reserveDining: 'Reserve Dining',
      personName: 'Person Name',
      personNamePlaceholder: 'Required, please enter person name',
      personTel: 'Person Tel',
      personTelPlaceholder: 'Required, please enter person tel',
      payWay: 'Pay Way',
      payWayPlaceholder: 'Please select pay way',
      cash: 'Cash',
      wechat: 'WeChat',
      alipay: 'Alipay',
      quantity: 'Quantity',
      quantityPlaceholder: 'Please select quantity',
      unit: 'unit',
      receivableAmount: 'Receivable Amount',
      receivableAmountPlaceholder: 'Required, please enter receivable amount',
      receivedAmount: 'Received Amount',
      receivedAmountPlaceholder: 'Required, please enter received amount',
      appointmentTime: 'Appointment Time',
      appointmentTimePlaceholder: 'Required, please select appointment time',
      openTime: 'Open Time',
      openTimePlaceholder: 'Please select open time',
      hour: 'hour',
      remark: 'Remark',
      remarkPlaceholder: 'Required, please enter remark'
    },
    deleteReserveDining: {
      confirmDelete: 'Confirm to delete reserve dining?'
    }
  },
  zh: {
    doDining: {
      selectGoods: '选择商品',
      scanQrCode: '请用扫码枪扫二维码',
      dining: '就餐',
      diningRecords: '就餐记录',
      selectStartTime: '请选择开始时间',
      selectEndTime: '请选择结束时间',
      enterOwnerName: '请输入业主名称',
      enterDinerName: '请输入就餐人',
      diningTime: '就餐时间',
      goods: '商品',
      owner: '业主',
      diner: '就餐人',
      dinerPhone: '就餐电话',
      orderNo: '订单编号',
      remark: '备注'
    },
    addReserveDiningPerson: {
      reserveDining: '预约就餐',
      personName: '预约人',
      personNamePlaceholder: '必填，请填写预约人',
      personTel: '预约电话',
      personTelPlaceholder: '必填，请填写预约电话',
      payWay: '支付方式',
      payWayPlaceholder: '请选择支付方式',
      cash: '现金',
      wechat: '微信',
      alipay: '支付宝',
      quantity: '预约数量',
      quantityPlaceholder: '请选择预约数量',
      unit: '个',
      receivableAmount: '应收金额',
      receivableAmountPlaceholder: '必填，请填写应收金额',
      receivedAmount: '实收金额',
      receivedAmountPlaceholder: '必填，请填写实收金额',
      appointmentTime: '预约日期',
      appointmentTimePlaceholder: '必填，请选择预约日期',
      openTime: '预约时间',
      openTimePlaceholder: '请选择预约时间',
      hour: '时',
      remark: '备注',
      remarkPlaceholder: '必填，请填写备注'
    },
    deleteReserveDining: {
      confirmDelete: '确定删除预约就餐?'
    }
  }
}